/** Converts UTC string date to local date */
export function parseServerDate<T>(dateString: T): T extends string | Date ? Date : Date | undefined {
  if (dateString === undefined || dateString === null || dateString.toString().startsWith('0001-01-01'))
    // biome-ignore lint/style/noNonNullAssertion: sacrifice style here for more useful function typing
    return undefined!;

  if (dateString instanceof Date) return dateString;

  let dateString2 = dateString as string;
  if (dateString2.includes('+')) dateString2 = dateString2.substring(0, dateString2.indexOf('+'));
  if (!dateString2.endsWith('Z')) dateString2 += 'Z';

  const date = new Date(dateString2);
  if (Number.isNaN(date.getTime())) throw new Error(`parseServerDate: Invalid date string (${dateString})`);

  return date;
}
